/* eslint-disable no-console */

let counter = 0;
export function deliverResizeLoopError(): void {
  const logger = counter++ > 20 ? console.error : console.debug;
  logger("ResizeObserver loop completed with undelivered notifications.");
}
